<!-- 字典下拉组件[多级]
  dict-type:字典类型
  select-parent:父节点可选
  show-all:显示所有
  <select-dict dict-type="country" v-model="" select-parent show-all></select-dict>
 -->
<template>
  <el-cascader v-model="selectValue" v-if=" optionList && optionList.length!==0"
               @change="selectChange"
               :change-on-select="changeOnSelect"
               :options="optionList"
               :props="{ checkStrictly: true ,emitPath:false}"
               :show-all-levels="showAllLevel" :filterable="filterable?filterable:false" ref="classifyDict" :placeholder="tipsValue"></el-cascader>
</template>

<script>
  export default {
    name: 'classify-dict',
    props: ['dictType', 'selectParent', 'showAll', 'modelValue','isAll','orgType','filterable','tipsValue','type'],
    data () {
      return {
        optionList:[],
        changeOnSelect: false,
        showAllLevel: false,
        selectValue: [],
        isSelect: false,
        result: [],
      };
    },
    watch: {
      modelValue: function (newValue, oldValue) {
        this.selectValue = newValue;
      }
    },
    methods: {
      selectChange: function (value) {
        this.$emit('update:modelValue', value);
      },
      initClassify(){
        this.simplePost("/api/business/goodsClassify/getAll",null,result=>{
          //console.log(result.data.filter(item => item.type === this.type));
          this.optionList.pushAll(result.data.filter(item=>item.position==this.type));
        },false);
      },
    },
    mounted () {
      this.$nextTick(()=>{
        this.changeOnSelect = (this.selectParent == '' || this.selectParent == 'true');
        this.showAllLevel = (this.showAll == '' || this.showAll == 'true');
        this.optionList = [];
        /*if((this.isAll == '' || this.isAll == 'true')){
          this.optionList.push({label:"全部",value:""});
        }else{
          this.optionList.push({label:this.tipsValue!=null?this.tipsValue:"请选择",value:""});
        }*/
        this.selectValue = this.modelValue;
        this.initClassify();
      })
    }
  }
</script>

<style lang="less" scoped>
  .el-cascader{
    line-height: 32px;
  }
</style>
